import { ProvisionCategoryCodes } from "@/modules/web_hosting/data/enums";
import { DocCategories } from "@/data/enums/docs";

export default [
  {
    path: "host",
    components: {
      default: {
        name: "HostControl",
        template: `<router-view />`
      }
    },
    meta: {
      breadcrumb: {
        label: "_.insights"
      },
      requiresBrand: true
    },
    children: [
      {
        path: "",
        name: "admin__hostControl",
        redirect: { name: "admin__hostControl::domains" }
      },
      {
        path: "domain-names",
        component: {
          name: "DomainNames",
          template: `<router-view />`
        },
        children: [
          {
            path: "",
            name: "admin__hostControl::domains",
            component: () =>
              import("@/modules/web_hosting/views/domain-names/index.vue"),
            props: {
              routes: require("./menu").DomainNamesTabigation,
              categoryCode: ProvisionCategoryCodes.DOMAINS
            },
            redirect: { name: "admin__hostControl::domainRegistrars" },
            children: [
              {
                path: "registrars",
                name: "admin__hostControl::domainRegistrars",
                component: () =>
                  import(
                    "@/modules/web_hosting/views/domain-names/registrars/index.vue"
                  ),
                meta: {
                  title: "_modules.web_hosting.domains.existing_registrars",
                  backTo: "_modules.web_hosting.domains.existing_registrars",
                  categorySlug: DocCategories.FOR_WEB_HOSTS,
                  docsSlugs: ["web-hosting-quick-start-guide", "domain-names"]
                }
              },
              {
                path: "tlds",
                name: "admin__hostControl::domainTlds",
                component: () =>
                  import(
                    "@/modules/web_hosting/views/domain-names/tlds/index.vue"
                  ),
                meta: {
                  title: "_modules.web_hosting.domains.tlds",
                  backTo: "_modules.web_hosting.domains.tlds",
                  docsSlugs: ["web-hosting-quick-start-guide", "domain-names"]
                }
              },
              {
                path: "widget",
                name: "admin__hostControl::domainWidgets",
                component: () =>
                  import(
                    "@/modules/web_hosting/views/domain-names/widgets/index.vue"
                  ),
                meta: {
                  title: "_modules.web_hosting.web_hosting.widgets",
                  backTo: "_modules.web_hosting.web_hosting.widgets",
                  categorySlug: DocCategories.FOR_WEB_HOSTS,
                  docsSlugs: ["web-hosting-quick-start-guide", "domain-names"]
                }
              },
              {
                path: "settings",
                name: "admin__hostControl::settings",
                component: () =>
                  import(
                    "@/modules/web_hosting/views/domain-names/settings/index.vue"
                  ),
                meta: {
                  title: "_.settings",
                  backTo: "_.settings"
                }
              }
            ]
          }
        ]
      },
      {
        path: "web-hosting",
        component: {
          name: "WebHosting",
          template: `<router-view />`
        },
        children: [
          {
            path: "",
            name: "admin__hostControl::hosting",
            component: () =>
              import("@/modules/web_hosting/views/web-hosting/index.vue"),
            props: {
              routes: require("./menu").WebHostingTabigation,
              categoryCode: ProvisionCategoryCodes.SHARED_HOSTING
            },
            redirect: { name: "admin__hostControl::hostingConfigurations" },
            children: [
              {
                path: "",
                redirect: "servers"
              },
              {
                path: "servers",
                name: "admin__hostControl::hostingConfigurations",
                component: () =>
                  import(
                    "@/modules/web_hosting/views/web-hosting/servers/index.vue"
                  ),
                meta: {
                  title: "_modules.web_hosting.web_hosting.web_servers",
                  backTo: "_modules.web_hosting.web_hosting.web_servers",
                  categorySlug: DocCategories.FOR_WEB_HOSTS,
                  docsSlugs: [
                    "web-hosting-quick-start-guide",
                    "sell-web-hosting",
                    "whmcs-alternative-upmind-comparison"
                  ]
                }
              },
              {
                path: "packages",
                name: "admin__hostControl::hostingPackages",
                component: () =>
                  import(
                    "@/modules/web_hosting/views/web-hosting/packages/index.vue"
                  ),
                meta: {
                  title: "_modules.web_hosting.web_hosting.web_hosting",
                  backTo: "_modules.web_hosting.web_hosting.web_hosting",
                  categorySlug: DocCategories.FOR_WEB_HOSTS,
                  docsSlugs: [
                    "web-hosting-quick-start-guide",
                    "sell-web-hosting",
                    "whmcs-alternative-upmind-comparison"
                  ]
                }
              }
            ]
          }
        ]
      },
      {
        path: "*",
        component: () => import("@/views/error/index.vue"),
        props: { code: 404 }
      }
    ]
  }
];
